import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import Hero, { heroImgStyles } from '~components/Hero';

import BoardMembers from '~components/PageSection/BoardMembers';

// Page Navigation
import PageNav from '~components/PageNav';
import EliLillyCard from '~components/PageCard/EliLillyCard';
import ResearchCard from '~components/PageCard/ResearchCard';

const StubPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Conseil d’administration 2020" desc="Description" />
      <Hero title="Conseil d’administration 2020">
        <StaticImage style={heroImgStyles} src="../images/board-of-directors-feature.jpg" alt="" />
      </Hero>
      <div tw="container">
        <BoardMembers />
        <PageNav previous={<EliLillyCard />} next={<ResearchCard />} />
      </div>
    </Layout>
  );
};

export default StubPage;
